import React from "react";
import styled from "styled-components";
const AlertCard = styled.div`
    border-radius:8px;
    &.red{
    .alertBox{
        border:1px solid rgba(236, 78, 44, 0.2);
        background-color:rgba(235, 78, 44, 0.1);
    }
    }
    &.green{
    .alertBox{
        border:1px solid rgba(63, 189, 97, 0.2);
        background-color:rgba(63, 190, 97, 0.1);;
    }
    }
    &.yellow{
        .alertBox{
            background: rgba(238, 149, 0, 0.1);
            border: 1px solid rgba(238, 149, 0, 0.2);
        }
    }
    &.blue{
        .alertBox{
            background: rgba(0, 108, 229, 0.1);
            border: 1px solid rgba(0, 108, 229, 0.2);
        }
    }
    .alertBox{
      padding:8px 30px 8px 12px;
      border-radius:8px;
      min-height:50px;
      width:100%;
      display:flex;
      .alertIcon{
          width:34px;
          height:34px;
          position:relative;
          top:2px;
          align-self:center;
          img{
              width:100%;
          }
      }
      p{
        color:var(--para-text);
        font-size:12px;
        line-height:16px;
        font-family:var(--sf-pro-display-m);
        margin-left:15px;
        margin-bottom:0px;
        width:calc(100% - 40px);
      }
    }
`;

const AlertRejectSummaryTableContainer = (props) => {
    return (<AlertCard className={props.color} > 
        <div className="alertBox">
            <div className="alertIcon">
                <img src={props.icon} alt=""/>
            </div>
            <p>{props.msg}</p>
        </div>
        </AlertCard>)
    }
export default AlertRejectSummaryTableContainer;